import ConfigManager from '@/config/ConfigManager';
import BzbsApi from '@/core/Http/BzbsApi.js';
import Util from "@/helper/Utility.js";
// import TransferPointConfig from './TransferPointConfigManager';
import CampaignModel from '@/core/Campaign/model/CampaignModel'
import PurchaseModel from '../model/PurchaseModel';
import { map } from 'rxjs/operators';

export default {
    getBaseUrl: function(apiPrefix) {
        var baseUrl = ConfigManager.getApiUrl();
        if (apiPrefix) {
            baseUrl = ConfigManager.getApiUrlWithPrefix.replace('{prefix}', apiPrefix);
        }
        return baseUrl;
    },
    /**
     * @param {Object} objDetailConfig (Require) CampaignConfigModel - /core/Campaign/model/CampaignConfigModel.js
     */
    apiGetCampaignDetail: function (objDetailConfig, token, apiPrefix, weblandingBlob) {
        var baseUrl = this.getBaseUrl(apiPrefix);
        var url;
        url = Util.getApiUrlFromWeblandingBlob(weblandingBlob, "iimmpact_detail", objDetailConfig.strId);
        if (!url) {
            url = `${baseUrl}/campaign/${objDetailConfig.strId}`;
        }

        var params = objDetailConfig.getParams();

        //url = 'http://localhost:3000' + `/campaign/${objDetailConfig.strId}`;
        return BzbsApi.connectBzbsGet(url, token, params)
            .pipe(map((res) => {
                var campaign = new CampaignModel(res.data);
                return campaign;
            }));
    },

    /**
     * @param {String|Number} campaignId
     * @param {Object} redeemParams
     * @param {String|Number} redeemQuantity
     */
    apiRedeemCampaign: function (campaignId, redeemParams, redeemQuantity, token, apiPrefix, weblandingBlob) {
        var baseUrl = this.getBaseUrl(apiPrefix);
        var url;
        url = Util.getApiUrlFromWeblandingBlob(weblandingBlob, "iimmpact_redeem", campaignId);
        if (!url) {
            url = `${baseUrl}/campaign/${campaignId}/redeem`;
        }

        var params = {...redeemParams};

        //url = 'http://localhost:3000' + `/campaign/${campaignId}/redeem`;
        if (!isNaN(redeemQuantity) && redeemQuantity > 1) {
            params.sp_points = redeemQuantity;
            // params.quantity = redeemQuantity;
            // url = ConfigManager.getApiUrl() + `/campaign/${campaignId}/bulkredeem`;
        }
        return  BzbsApi.connectBzbsPost(url, token, params).pipe(map(res => res.data));
    },

    apiGetHistory: function (redeemKey, token, weblandingBlob) {
        var url;
        url = Util.getApiUrlFromWeblandingBlob(weblandingBlob, "iimmpact_history", redeemKey);

        return BzbsApi.connectBzbsGet(url, token, null)
            .pipe(map((res) => {
                var purchase = new PurchaseModel(res.data)
                return purchase
            }));
    },

}
